export const ENABLE_NEW_PERMISSION_UI_COMPANY: boolean = true;
export const ENABLE_NEW_PERMISSION_UI_BRAND: boolean = true;
export const ENABLE_NEW_PERMISSION_UI_WORKSPACE: boolean = true;
export const ENABLE_NEW_PERMISSION_UI_CAMPAIGN: boolean = true;
export const ENABLE_NEW_PERMISSION_UI_PROJECT: boolean = true;
